import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../'

const selectAutosave = (state: RootState) => state.autosave

export const selectEngagements = createSelector(
  selectAutosave,
  autosave => autosave.engagements,
)
